import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            shiftInPixels: vector2Like,
        }),
    },
}
